import React from 'react'

import { PhotoThumbnail } from '@components/common/PhotoThumbnail'
import { getProductThumbnailType } from '@utils/products'

import type { Product } from '../../types'
import { EmbeddedProductsTooltip } from '../EmbeddedProductsTooltip'
import * as S from './ProductThumbnailWithTooltip.styled'

export type ProductThumbnailWithTooltipProps = {
  product: Pick<Product, 'thumbnail' | 'type' | 'embeddedOffers'>
  size: 'extraLarge' | 'large'
}

export const ProductThumbnailWithTooltip = ({
  product,
  size,
}: ProductThumbnailWithTooltipProps) => {
  const hasEmbeddedOffers =
    (product.type === 'COMBINED' || product.type === 'BUNDLE') &&
    product.embeddedOffers &&
    product.embeddedOffers.length > 0

  return (
    <S.ThumbnailWrapper>
      <PhotoThumbnail
        url={product.thumbnail}
        size={size}
        type={getProductThumbnailType(product.type)}
      />
      {hasEmbeddedOffers && (
        <>
          <S.ProductCountBadge>{product.embeddedOffers!.length}</S.ProductCountBadge>
          <S.HoverTooltip>
            <EmbeddedProductsTooltip embeddedOffers={product.embeddedOffers!} />
          </S.HoverTooltip>
        </>
      )}
    </S.ThumbnailWrapper>
  )
}
